import { Footer } from '../components/Footer';
import { Layout } from '../components/Layout';
import { PoliticaPrivacidadeComponent } from '../components/sections/PoliticaPrivacidade';

export const PoliticaPrivacidade = () => {
  window.scrollTo(0, 0);

  return (
    <Layout>
      <PoliticaPrivacidadeComponent />
      <Footer />
    </Layout>
  );
};
